import { section } from "@/neon";

import { animateFeaturedCollectionGrid } from "@/lib/animation";

section("featured-collection-grid", {
  onLoad() {
    this.animateFeaturedCollectionGrid = animateFeaturedCollectionGrid(
      this.container
    );
  },

  onUnload() {
    this.animateFeaturedCollectionGrid?.destroy();
  },
});
